import { memo, useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import s from './DropDownMenu.module.scss'

import { ArrowDownIcon } from 'assets/icons/ArrowDownIcon'

interface Props {
  isLoggedIn?: boolean
  links: { to: string; label: string, onLinkClick?: () => void}[]
  title: string
  icon: React.ReactNode
  variant: 'primary' | 'secondary'
  disabled?: boolean
  width?: number
  onMenuClick?: () => void
  withoutLogin?: boolean
}

export const DropDownMenu = memo((props: Props) => {
  const { isLoggedIn, links, title, icon, variant, disabled, width, withoutLogin, onMenuClick } = props
  const [isMenuExpanded, setIsMenuExpanded] = useState(false)
  const navigate = useNavigate()
  return (
    <div className={s.dropLinks} style={{ width: width ? width : '100%' }}>
      <button
        type="button"
        className={s.sidebarButton}
        onClick={() => {
          setIsMenuExpanded(!isMenuExpanded)
          if (!withoutLogin && !isLoggedIn) navigate('login', { replace: true })
          if(onMenuClick) onMenuClick()
        }}
        disabled={disabled}
      >
        <div className={s.iconWrapper}>{icon}</div>
        {title}
        <ArrowDownIcon
          className={s.arrowIcon}
          style={{ transform: isMenuExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.5s' }}
        />
      </button>
      {isLoggedIn && (
        <div className={`${s.dropContent} ${isMenuExpanded && s.menuExpanded}`}>
          <div style={{ minHeight: 0 }}>
            {links.map((link) => (
              <NavLink
                to={link.to}
                key={link.to}
                className={({ isActive }) => (isActive ? `${s.active} ${s[variant]}` : s[variant])}
                style={{ display: isMenuExpanded ? 'block' : 'none' }}
                onClick={link.onLinkClick}
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </div>
  )
})
